"use client";

import React, { useState } from 'react';

const faqs = [
  {
    question: "Ile kosztuje monitoring domu?",
    answer: "Cena zależy od liczby kamer, ich rodzaju (wewnętrzne/zewnętrzne, 4K, z zoomem) oraz dodatkowych funkcji (AI, LPR, integracje). Podstawowy system dla domu jednorodzinnego zaczyna się od 4500–6500 zł. Przygotujemy bezpłatną, indywidualną wycenę."
  },
  {
    question: "Czy mogę oglądać kamery na telefonie?",
    answer: "Tak. Konfigurujemy aplikację mobilną (iOS i Android) z podglądem na żywo, powiadomieniami push i możliwością odtwarzania nagrań. Robimy to w dniu montażu."
  },
  {
    question: "Jak długo przechowywane są nagrania?",
    answer: "Standardowo 14–30 dni (w zależności od ustawień). Na życzenie klienta możemy zwiększyć pojemność dysków lub dodać nagrywanie w chmurze."
  },
  {
    question: "Czy monitoring działa bez internetu?",
    answer: "Tak. System nagrywa lokalnie na rejestratorze niezależnie od internetu. Dostęp zdalny i powiadomienia wymagają połączenia internetowego, ale monitoring działa bez przerwy."
  },
  {
    question: "Czy mogę dokupić kamery w przyszłości?",
    answer: "Tak. Projektujemy systemy skalowalne. W każdej chwili możemy dodać kolejne kamery lub rozszerzyć rejestrator."
  },
  {
    question: "Czy zajmujecie się też serwisem po montażu?",
    answer: "Tak. Oferujemy 2-letnią gwarancję na sprzęt i montaż oraz płatny serwis pogwarancyjny. Posiadamy też pakiet wsparcia 24/7."
  },
  {
    question: "Jak długo trwa montaż systemu?",
    answer: "Standardowy montaż w domu lub małej firmie trwa 1 dzień. Większe obiekty (magazyny, osiedla) – zwykle 2-4 dni, w zależności od skali projektu."
  },
  {
    question: "Czy oferujecie monitoring zdalny z centrum?",
    answer: "Tak. Na życzenie klienta podłączamy system do naszego centrum monitoringu lub zapewniamy stały dostęp zdalny z powiadomieniami w czasie rzeczywistym."
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const scrollToContact = () => {
    const el = document.getElementById('kontakt');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="faq" className="max-w-screen-2xl mx-auto px-8 py-20">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <div className="text-blue-500 font-semibold tracking-[2px] text-sm mb-2">FAQ</div>
          <h2 className="text-4xl font-semibold tracking-tighter">Najczęściej zadawane pytania</h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div 
                key={index} 
                className="dark-card rounded-3xl overflow-hidden border border-zinc-800"
              >
                <button
                  onClick={() => toggle(index)}
                  className="w-full flex justify-between items-center px-7 py-5 text-left font-medium hover:bg-zinc-900 transition-colors"
                >
                  <span>{faq.question}</span>
                  <span className={`text-2xl transition-transform ${isOpen ? 'rotate-45' : ''}`}>+</span>
                </button>
                {isOpen && (
                  <div className="px-7 pb-6 text-zinc-400 leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <p className="text-zinc-400 mb-4">Nie znalazłeś odpowiedzi na swoje pytanie?</p>
          <button 
            onClick={scrollToContact}
            className="font-semibold text-blue-400 hover:text-blue-300"
          >
            Zapytaj nas bezpośrednio →
          </button>
        </div>
      </div>
    </section>
  );
}
